const STAFF_NAME = Object.freeze({
  all: 'All staff',
  salon: 'Business view',
  employed: 'Employed staff only',
  self: 'Self-employed staff only',
});

// noinspection JSUnusedGlobalSymbols
export default STAFF_NAME;
